import { render, staticRenderFns } from "./Archivist.vue?vue&type=template&id=be1fa106"
import script from "./Archivist.vue?vue&type=script&lang=js"
export * from "./Archivist.vue?vue&type=script&lang=js"
import style0 from "./Archivist.vue?vue&type=style&index=0&id=be1fa106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports